import React from 'react';

export default function(props) {
    let { colSpan, key, type: Component } = props,
        { type, ...others } = props;

    if(colSpan > 1000) {
        let count = Math.ceil(colSpan / 1000);
        return <>
            {new Array(count).map((_, index) =>
                <Component {...others} key={`${key}-${index}`} colSpan={index === count - 1 ? colSpan - index * 1000 : 1000}></Component>,
            )}
        </>;
    } else {
        return <Component {...others}></Component>;
    }

}